<template>
  <v-card v-if="quote.instructed == 1">
    <v-card-text>
      <h2><v-icon>how_to_vote</v-icon>CQS</h2>
      <template v-if="selectedHeaderElement != 2">
        <div>
          <strong>Requirements</strong>
        </div>
        <span
          >Have you discussed the client's requirements and objectives, provided
          an explanation as to any issues raised and explained timescales to
          them?</span
        >
        <span :class="quote.cqsconfirm ? 'ipAddress' : 'ipAddressBlack'">
          &#160;
          <strong>{{ quote.cqsconfirm }}</strong>
        </span>
        <template v-if="quote.cqsnote">
          <div>
            <strong>File note</strong>
          </div>
          <div>{{ quote.cqsnote }}</div>
        </template>
        <br />
        <v-btn @click="$emit('changeSelectedHeaderElement', 2)" small>
          <v-icon>edit</v-icon>Change
        </v-btn>
      </template>
      <template v-if="selectedHeaderElement == 2">
        <div class="ajaxForm">
          <v-checkbox v-model="cqsconfirm" label="Discussed requirements" />
          <v-textarea box label="Strategy" v-model="cqsnote" />
          <v-btn @click="updateCqs"> <v-icon>save</v-icon>Save </v-btn>
          <v-btn @click="$emit('changeSelectedHeaderElement', 0)">
            <v-icon>undo</v-icon>Cancel
          </v-btn>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Cqs",
  props: ["quote", "lastUpdated", "selectedHeaderElement"],
  data() {
    return { cqsconfirm: null, cqsnote: null };
  },
  methods: {
    async updateCqs() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.quote.id}/cqs/${this.cqsconfirm}`,
        { value: this.cqsnote }
      );
      // console.log(response.data);
      this.$emit("changeSelectedHeaderElement", 0);
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.cqsconfirm = this.quote.cqsconfirm;
        this.cqsnote = this.quote.cqsnote;
      }
    }
  }
};
</script>